import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import Final from "../img/setupapracticeinfo.jpg";
import "../css/servicesfont.css";
const StartPracticeDesc = () => {
  return (
    <MDBContainer fluid className="p-0 bg-light">
      <div className="container py-5">
        <h2 className="text-center pb-4 AcerhealthTextPurple fomtsizetest" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>How You Will Get the Benefits</h2>
        <div className="row">
          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-12">
                <h3 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                  Low Upfront Costs & No Long-term Contracts
                </h3>
                <p  className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify' }}>
              At <b>AcerHealth,</b> we believe in earning your trust through performance—not binding contracts. That’s why we offer <b>affordable medical billing 
              services </b>with minimal upfront investment and <b>no long-term commitments.</b> Our pricing is transparent, with <b>no hidden fees, costly upgrades,
               or maintenance charges.</b> Our incentive-driven model aligns with your financial goals, helping you maximize collections from day one.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-12">
                <h3 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                Assisting with Administrative Burden to Prioritize Provider-Patient Interaction
                </h3>
                <p  className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify' }}>
               At <b>AcerHealth,</b> we help healthcare providers reduce administrative burden so they can focus more on patient care. 
               From <b>eligibility checks </b>and
               <a
                            href="https://acerhealth.com/technologies/patient-statements-payment-portal"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
               payment posting 
                        </a>  
              to denial management and reminder calls, we handle the backend tasks with speed and accuracy.
                Our up-to-date <b>billing rules engine </b>ensures compliance with changing <b>payer requirements, </b>minimizing errors and denials. 
                As a trusted 
                 <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                medical billing services
                        </a> partner, we streamline your operations, reduce overhead, and improve <b>revenue cycle management </b>without adding extra staff.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-12 mb-5">
            <div className='card'>
            <div className="row">
              <div class="col-md-12 text-center">
              <img src={Final} height="725px" with="100%" alt="Medical billing for small practices"/>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
};
export default StartPracticeDesc;
